import React, { PureComponent } from "react";
import { Helmet } from "react-helmet";

class SchedulerHomePage extends PureComponent {
  render() {
    return (<div>
      <Helmet title="Scheduler | PubNinja - You Publish. The rest we manage" />
      {this.props.children}
    </div>)
  }
}
export default SchedulerHomePage;